import { useEffect } from 'react'
import { usePostHog } from 'posthog-js/react'

import { useAuth } from '@/features/auth/use-auth.ts'

export const Identifier = () => {
  const auth = useAuth()
  const posthog = usePostHog()

  useEffect(() => {
    if (auth?.user) {
      posthog?.identify(auth.user.id, {
        email: auth.user.email,
      })
    }
  }, [auth.user, posthog])

  return null
}
